import * as types from './actionTypes';
import {API_ROOT} from '../../baseUrls';
import {buildFormData} from './actionUtils'

export function getFriends(mid) {
    return function (dispatch, getState) {
        fetch(`${ API_ROOT }/mindfiles/${ mid }/friends`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
    .then((response) => {
        response.json()
        .then((data) => {
          let cleanData = data.map(function(item) {
            if (item.hasOwnProperty('person_mindfile')) {
              return item.person_mindfile;
            } else {
              return null;
            }
          });
          cleanData = cleanData.filter(function(item) { return item !== null });
          dispatch({
            type: types.GET_FRIENDS,
            payload: cleanData
          });
        })
        .catch(err => console.error(err));
      }
    );
  }
}

export function getMindfile(mid, callback = () => {}, incSize=false) {
    return function (dispatch, getState) {
        const state = getState();
    const loggedInUid = state.auth.uid;
    const sizeParam = incSize ? "/?size=1" : "";
    dispatch({type: types.LOADING_MINDFILE, payload: true});
    fetch(`${ API_ROOT }/mindfiles/${ mid }${sizeParam}`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': state.auth.authenticity_token},
    })
    .then(resp => resp.json())
    .then((data) => {
      if (data.status === 'ok') {
        dispatch({
          type: types.GET_MINDFILE,
          payload: {
            id: data.id,
            default: data.default,
            owner: data.owner,
            owner_username: data.owner_username,
            owner_email: data.owner_email,
            name: data.name,
            bot_name: data.bot_name,
            birthday: data.birthday,
            school: data.school,
            location: data.location,
            upload_count: data.upload_count,
            upload_size: data.upload_size,
            created_at: data.created_at,
            privacy_level: data.privacy_level,
            group: data.group,
            photos: data.photos,
            timestamp: data.timestamp,
            picture: `/mindfiles/${ mid }/avatar/thumbnail?size=48&ts=${data.timestamp}`,
            picturesUploading: 0,
            loggedInUid: loggedInUid,
            contributors: data.contributors,
            requests: data.requests,
            invitations_sent: data.invitations_sent,
            invitations_received: data.invitations_received,
            contributor_requests: data.contributor_requests,
            bot_unique: data.bot_unique,
            bot_security: data.bot_security,
            has_avatar_photo: data.has_avatar_photo,
          },
        });
        getFriends(mid)(dispatch,getState)
        // getMindfileUploads(mid)(dispatch,getState)

      } else {
        // TODO: what to do if user tries to fetch a private mindfile.
      }
    })
    .catch(err => console.error(err))
    .finally(() => {
      dispatch({type: types.LOADING_MINDFILE, payload: false});
      callback();
    });
  }
}

export function getCurrentUserMindfiles() {
    return function (dispatch, getState) {
        fetch(`${ API_ROOT }/mindfiles/list`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: types.GET_CURRENT_USER_MINDFILES,
        payload: data.map((m) => ({
          id: m.id,
          owner: m.owner,
          name: m.name,
          bot_name: m.bot_name,
          privacy: m.privacy,
          birthday: m.birthday,
          school: m.school,
          location: m.location,
          privacy_level: m.privacy_level,
          group: m.group,
          photos: m.photos,
          contributors: m.contributors,
          timestamp: m.timestamp,
          picture: `/mindfiles/${ m.id }/avatar/thumbnail?size=48&ts=${m.timestamp}`,
        }))
      })
    })
    .catch(err => console.error(err));
  }
}

export function getMindfileItem(mid, mindfile_item_id, update_view_count, callback = (data) => {}) {
  return function (dispatch, getState) {
    dispatch({
      type: types.SET_VIEW_ITEM_STATUS,
      payload: 'processing'
    })
    const urlEnd = update_view_count ? "?update=1" : "";
    fetch(`${ API_ROOT }/mindfiles/${ mid }/items/${ mindfile_item_id }/view${urlEnd}`, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: types.GET_MINDFILE_ITEM,
          payload: data
        });
        return data;
      })
      .then(data => callback(data))
      .catch(err => console.error(err))
      .finally(() => dispatch({
          type: types.SET_VIEW_ITEM_STATUS,
          payload: 'done'
        })
      );
  }
}
export function setViewItem(item, callback = (data) => {}) {
  return function (dispatch, getState) {
    new Promise((resolve, reject) => {
      dispatch({
        type: types.GET_MINDFILE_ITEM,
        payload: item
      })
      resolve(true);
      return item;
    })
      .then(data => callback(data))
      .finally(() => dispatch({
          type: types.SET_VIEW_ITEM_STATUS,
          payload: 'done'
        })
      );
  }
}
export function setSelectedItems(selectedItems, callback = (data) => {}) {
  return function (dispatch, getState) {
    new Promise((resolve, reject) => {
      dispatch({
        type: types.SET_SELECTED_MINDFILE_ITEMS,
        payload: selectedItems
      })
      resolve(true);
      return selectedItems;
    })
      .then(data => callback(data));
  }
}
export function setSelectedFolders(selectedFolders, callback = (data) => {}) {
  return function (dispatch, getState) {
    new Promise((resolve, reject) => {
      dispatch({
        type: types.SET_SELECTED_FOLDERS,
        payload: selectedFolders
      })
      resolve(true);
      return selectedFolders;
    })
      .then(data => callback(data));
  }
}

export function getMindfileItemsDetails(mid, mindfile_item_ids, callback=(data) => {}, signal=null) {
  return function (dispatch, getState) {
    if(!mindfile_item_ids || mindfile_item_ids.length === 0){
      return;
    }
    const formData = new FormData();
    mindfile_item_ids.forEach((id,i) => {
      formData.append('mindfile_item_ids[]', id);
    });
    fetch(`${ API_ROOT }/mindfiles/${ mid }/items/status`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    }, signal)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: types.GET_MINDFILE_ITEM_DETAILS,
        payload: data
      });
      return data;
    })
    .then(data => callback(data))
    .catch(err => console.error(err));
  }
}

export function getFolderList(mid, callback = () => {}) {
  return function(dispatch, getState) {
    let url = new URL(`${ API_ROOT }/mindfiles/${ mid }/folders/list`)
    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: types.GET_FOLDER_LIST,
        payload: data,
      })
    })
    .catch(err => console.error(err))
    .finally(() => callback());
  }
}

export function getFolders(pageKey, mid, controller, filters, callback = () => {}) {
  return function(dispatch, getState) {
    const firstOrder = controller.orders[0];
    const nullSort = firstOrder.hasOwnProperty('n') ? (firstOrder.n ? 'last' : 'first') : 'last';
    const dir = nullSort === 'first' ? 'asc' : firstOrder.d ? 'asc' : 'desc';
    let order = [{f: firstOrder.f, d: dir, n: nullSort}];
    let url = new URL(`${ API_ROOT }/mindfiles/${ mid }/folders/view`)

    fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: buildFormData({
        'search': controller.search,
        'order': order,
        'limit': controller.rowsPerPage,
        'offset': (controller.page-1)*controller.rowsPerPage,
        'status': filters.status || [],
        'keywords': filters.keywords || [],
        'people': filters.people || [],
        'folders': filters.folders || [],
        'emotions': filters.emotions || [],
        'bemes': filters.bemes || [],
        'item_data_types': filters.item_data_types || [],
        'upload_types': filters.upload_types || [],
        'sources': filters.sources || [],
        'survey_names': filters.survey_names || [],
        'survey_complete': filters.survey_complete || [],
      }),
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: types.GET_FOLDERS,
        payload: {...data, pageKey: pageKey},
      })
    })
    .catch(err => console.error(err))
    .finally(() => callback());
  }
}

export function getFolderDetails(mid, folderId, callback = () => {}) {
  return function(dispatch, getState) {
    let url = new URL(`${ API_ROOT }/mindfiles/${ mid }/folder/${ folderId }/details`)
    let dataVal = null;
    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        dataVal = data;
        dispatch({
          type: types.GET_FOLDER_DETAILS,
          payload: data,
        })
      })
      .catch(err => console.error(err))
      .finally(() => callback(dataVal));
  }
}

export function getMindfileItems(pageKey, mid, controller, filters, mapBounds, callback = () => {}) {
  return function(dispatch, getState) {
    const firstOrder = controller.orders[0];
    const nullSort = firstOrder.hasOwnProperty('n') ? (firstOrder.n ? 'last' : 'first') : 'last';
    const dir = nullSort === 'first' ? 'asc' : firstOrder.d ? 'asc' : 'desc';
    let order = [{f: firstOrder.f, d: dir, n: nullSort}];
    let url = new URL(`${ API_ROOT }/mindfiles/${ mid }/items/search`);
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: buildFormData({
        'search': controller.search,
        'order': order,
        'limit': controller.rowsPerPage,
        'offset': (controller.page-1)*controller.rowsPerPage,
        'status': filters.status || [],
        'keywords': filters.keywords || [],
        'people': filters.people || [],
        'folders': filters.folders || [],
        'emotions': filters.emotions || [],
        'bemes': filters.bemes || [],
        'item_data_types': filters.item_data_types || [],
        'upload_types': filters.upload_types || [],
        'sources': filters.sources || [],
        'latlng': mapBounds || {},
        'spacecast': filters.spacecast || [],
        'survey_names': filters.survey_names || [],
        'survey_complete': filters.survey_complete || [],
      }),
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({
          type: types.GET_ITEMS,
          payload: {...data, pageKey: pageKey},
        });
        !!data.items && dispatch({
          type: types.GET_MINDFILE_ITEMS,
          payload: data.items,
        });
      })
      .catch(err => console.error(err))
      .finally(() => callback());
  }
}

let locationSet = 0;
export function getMindfileItemLocations(mid, controller, filters, firstBatchCallback = () => {}, batchCallback = () => {}, allCallback = () => {}, limit=2500, offset=0, batch=true) {
  return function(dispatch, getState) {
    const setId = new Date().getTime() + locationSet;
    locationSet++;
    const url = new URL(`${ API_ROOT }/mindfiles/${ mid }/items/locations`);
    fetchLocations(setId, url, dispatch, getState, mid, controller, filters, firstBatchCallback, null, limit, offset, batch)
      .then((data) => {
        !!allCallback && allCallback(data);
        return data;
      })
      .catch(err => console.error(err));
  }
}
export function getMindfileItemLocationsPublic(mid, controller, filters, firstBatchCallback = () => {}, batchCallback = () => {}, allCallback = () => {}, limit=2500, offset=0, batch=true) {
  return function(dispatch, getState) {
    const setId = new Date().getTime() + locationSet;
    locationSet++;
    const url = new URL(`${ API_ROOT }/spacecast/${ mid }/locations`);
    fetchLocations(setId, url, dispatch, getState, mid, controller, filters, firstBatchCallback, null, limit, offset, batch)
      .then((data) => {
        !!allCallback && allCallback(data);
        return data;
      })
      .catch(err => console.error(err));
  }
}
export function getMindfileLocations(mid, controller, filters, firstBatchCallback = () => {}, batchCallback = () => {}, allCallback = () => {}, limit=2500, offset=0, batch=true) {
  return function(dispatch, getState) {
    const setId = new Date().getTime() + locationSet;
    locationSet++;
    const url = new URL(`${ API_ROOT }/admin/${ mid }/locations`);
    fetchLocations(setId, url, dispatch, getState, mid, controller, filters, firstBatchCallback, null, limit, offset, batch)
      .then((data) => {
        !!allCallback && allCallback(data);
        return data;
      })
      .catch(err => console.error(err));
  }
}
export function fetchLocations(setId, url, dispatch, getState, mid, controller, filters, firstBatchCallback, batchCallback, limit, offset, batch) {
  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    body: buildFormData({
      'search': controller.search,
      'limit': limit,
      'offset': offset,
      // 'status': filters.status || [],
      // 'keywords': filters.keywords || [],
      // 'people': filters.people || [],
      // 'folders': filters.folders || [],
      // 'emotions': filters.emotions || [],
      // 'bemes': filters.bemes || [],
      // 'item_data_types': filters.item_data_types || [],
      // 'upload_types': filters.upload_types || [],
      // 'sources': filters.sources || [],
      // 'spacecast': filters.spacecast || [],
      ...filters
    }),
    headers: {'X-CSRF-Token': getState().auth.authenticity_token},
  })
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: types.GET_ITEM_LOCATIONS_BATCH,
        payload: {setId: setId, locations: data.locations},
      });
      return data;
    })
    .then((data) => {
      if(!!firstBatchCallback){
        firstBatchCallback(data);
      }else {
        !!batchCallback && batchCallback(data);
      }
      return data;
    })
    .then(async (data) =>{
      let batchLocations = [...data.locations];
      if(batch){
        if(data.count > data.offset + data.locations.length){
          await Promise.all(
            [fetchLocations(setId, url, dispatch, getState, mid, controller, filters, null, newData => {
              batchLocations = [...batchLocations, ...newData.locations]
            }, limit, offset+data.locations.length, batch)]);
        }
      }
      return {...data, setId:setId, locations:batchLocations};
    })
    .catch(err => console.error(err));
}

export function getMindfilePhotos(mid, callback = () => {}) {
    return function (dispatch, getState) {
        fetch(`${ API_ROOT }/mindfiles/${ mid }/photos`, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
    .then(resp => resp.json())
    .then(data => dispatch({
      type: types.GET_MINDFILE_PHOTOS,
      payload: data.photos,
    }))
    .catch(err => console.error(err))
    .finally(() => callback());
  }
}

export function getSpacecastSettings() {
    return function (dispatch, getState) {
        const mid = getState().mindfile.id;
    fetch(`${API_ROOT}/mindfiles/${mid}/spacecast-settings`, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: types.GET_SPACECAST_SETTINGS,
        payload: data,
      });
    })
    .catch(err => console.error(err));
  }
}

export function getMultiuserMindfiles(pageKey, mid, controller, filters, mapBounds, callback = () => {}) {
  return function(dispatch, getState) {
    const firstOrder = controller.orders[0];
    const nullSort = firstOrder.hasOwnProperty('n') ? (firstOrder.n ? 'last' : 'first') : 'last';
    const dir = nullSort === 'first' ? 'asc' : firstOrder.d ? 'asc' : 'desc';
    let order = [{f: firstOrder.f, d: dir, n: nullSort}];
    let url = new URL(`${ API_ROOT }/mindfiles/${mid}/multiuser/search`)
    // const filterFields = Object.entries(filters).filter((k,v) => !!v && v.length > 0)
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: buildFormData({
        'search': controller.search,
        'order': order,
        'limit': controller.rowsPerPage,
        'offset': (controller.page-1)*controller.rowsPerPage,
        'latlng': mapBounds || {},
        ...filters
      }),
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({
          type: types.MULTI_USER_MINDFILES,
          payload: {...data, pageKey: pageKey},
        })
      })
      .catch(err => console.error(err))
      .finally(() => callback());
  }
}

export function getMultiuserLocations(mid, controller, filters, firstBatchCallback = () => {}, batchCallback = () => {}, allCallback = () => {}, limit=2500, offset=0, batch=true) {
  return function(dispatch, getState) {
    const setId = new Date().getTime() + locationSet;
    locationSet++;
    const url = new URL(`${ API_ROOT }/mindfiles/${ mid }/multiuser/locations`);
    fetchLocations(setId, url, dispatch, getState, mid, controller, filters, firstBatchCallback, null, limit, offset, batch)
      .then((data) => {
        !!allCallback && allCallback(data);
        return data;
      })
      .catch(err => console.error(err));
  }
}


export function getUserViewOpts(mid, callback=()=>{}) {
  return function (dispatch, getState) {
    const state = getState();
    const authToken = state.auth.authenticity_token;
    fetch(`${API_ROOT}/mindfiles/${mid}/view_options/list`,{
      credentials: 'include',
      headers: {'X-CSRF-Token': authToken},
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({type: types.GET_USER_VIEW_OPTS, payload: data});
        return data;
      })
      .then(viewOpts => callback(viewOpts))
      .catch(err => console.error(err));
  }
}

export function getUsageData(pageKey, mid, controller, filters, mapBounds, callback = () => {}) {
  return function(dispatch, getState) {
    const firstOrder = controller.orders[0];
    const nullSort = firstOrder.hasOwnProperty('n') ? (firstOrder.n ? 'last' : 'first') : 'last';
    const dir = nullSort === 'first' ? 'asc' : firstOrder.d ? 'asc' : 'desc';
    let order = [{f: firstOrder.f, d: dir, n: nullSort}];
    let url = new URL(`${ API_ROOT }/admin/user_stats`)
    // const filterFields = Object.entries(filters).filter((k,v) => !!v && v.length > 0)
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: buildFormData({
        'search': controller.search,
        'order': order,
        'limit': controller.rowsPerPage,
        'offset': (controller.page-1)*controller.rowsPerPage,
        'latlng': mapBounds || {},
        ...filters
      }),
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({
          type: types.USAGE_DATA,
          payload: {...data, pageKey: pageKey},
        })
      })
      .catch(err => console.error(err))
      .finally(() => callback());
  }
}





export function getMindfileItemAdmin(mid, mindfile_item_id, update_view_count, callback = (data) => {}) {
  return function (dispatch, getState) {
    dispatch({
      type: types.SET_VIEW_ITEM_STATUS,
      payload: 'processing'
    })
    const urlEnd = update_view_count ? "?update=1" : "";
    fetch(`${ API_ROOT }/admin/${mid}/items/${ mindfile_item_id }/view${urlEnd}`, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: types.GET_MINDFILE_ITEM,
          payload: data
        });
        return data;
      })
      .then(data => callback(data))
      .catch(err => console.error(err))
      .finally(() => dispatch({
          type: types.SET_VIEW_ITEM_STATUS,
          payload: 'done'
        })
      );
  }
}

export function getMindfileItemPublic(mid, mindfile_item_id, update_view_count, callback = (data) => {}) {
  return function (dispatch, getState) {
    dispatch({
      type: types.SET_VIEW_ITEM_STATUS,
      payload: 'processing'
    })
    const urlEnd = update_view_count ? "?update=1" : "";
    fetch(`${ API_ROOT }/spacecast/${mid}/${ mindfile_item_id }/view${urlEnd}`, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: types.GET_MINDFILE_ITEM,
          payload: data
        });
        return data;
      })
      .then(data => callback(data))
      .catch(err => console.error(err))
      .finally(() => dispatch({
          type: types.SET_VIEW_ITEM_STATUS,
          payload: 'done'
        })
      );
  }
}

export function getMindfileItemsPublic(pageKey, mid, controller, filters, mapBounds, callback = () => {}) {
  return function(dispatch, getState) {
    const firstOrder = controller.orders[0];
    const nullSort = firstOrder.hasOwnProperty('n') ? (firstOrder.n ? 'last' : 'first') : 'last';
    const dir = nullSort === 'first' ? 'asc' : firstOrder.d ? 'asc' : 'desc';
    let order = [{f: firstOrder.f, d: dir, n: nullSort}];
    let url = new URL(`${ API_ROOT }/spacecast/${mid}/search`);
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: buildFormData({
        'search': controller.search,
        'order': order,
        'limit': controller.rowsPerPage,
        'offset': (controller.page-1)*controller.rowsPerPage,
        'status': filters.status || [],
        'keywords': filters.keywords || [],
        'people': filters.people || [],
        'folders': filters.folders || [],
        'emotions': filters.emotions || [],
        'bemes': filters.bemes || [],
        'item_data_types': filters.item_data_types || [],
        'upload_types': filters.upload_types || [],
        'sources': filters.sources || [],
        'latlng': mapBounds || {},
        'spacecast': filters.spacecast || [],
        'survey_names': filters.survey_names || [],
        'survey_complete': filters.survey_complete || [],
      }),
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({
          type: types.GET_ITEMS,
          payload: {...data, pageKey: pageKey},
        });
        !!data.items && dispatch({
          type: types.GET_MINDFILE_ITEMS,
          payload: data.items,
        });
      })
      .catch(err => console.error(err))
      .finally(() => callback());
  }
}

export function updateItemViewCountPublic(mid, mindfile_item_id, callback=()=>{}) {
  return function (dispatch, getState) {
    fetch(`${ API_ROOT }/spacecast/${mid}/${ mindfile_item_id }/viewing`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(err => console.error(err));
  }
}

export function getImportSources(mid, callback=()=>{}) {
  return function (dispatch, getState) {
    fetch(`${ API_ROOT }/mindfiles/${mid}/sources`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => dispatch({
          type: types.IMPORT_SOURCES,
          payload: data,
        }))
      .catch(err => console.error(err))
      .finally(() => callback());
  }
}

export function startImportFromSource(mid, source, formData, callback=()=>{}) {
  return function (dispatch, getState) {
    fetch(`${ API_ROOT }/mindfiles/${mid}/${source}/import`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
      body: formData,
    })
      .then(resp => resp.json())
      .then(data => {
        if(data.status !== "error") {
          dispatch({
            type: types.IMPORT_SOURCES,
            payload: data,
          });
        }
      })
      .catch(err => console.error(err))
      .finally(() => callback());
  }
}

export function cancelImportFromSource(mid, source, callback=()=>{}) {
  return function (dispatch, getState) {
    fetch(`${ API_ROOT }/mindfiles/${mid}/${source}/cancel`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        if(data.status !== "error") {
          dispatch({
            type: types.IMPORT_SOURCES,
            payload: data,
          });
        }
      })
      .catch(err => console.error(err))
      .finally(() => callback());
  }
}
